import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Button, ProgressLoader } from "../Elements";
import { useLoading } from "../../../hooks/useLoading";
import { ListItemIcon, Menu, MenuItem, Typography, } from "@mui/material";
import { AddCircle, Sync, Edit, FormatListBulleted } from "@mui/icons-material";
import MaterailTable from "../Elements/MaterialTable";
import { changeIntegrationLoading, getIntegrationList, updateIntegrationList } from "../../../store/slices/IntegrationSlice";
import { FaEllipsisV, } from "react-icons/fa";
import ConfirmationModal from "../ConfirmationModal"
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { customerSelectFrom, integrationRequestTypes, openFormByParameter, openFormOperationType, postMessageTypes } from "../../../constants/postMessageFileds";
import { generateUUID } from "../../../common/helpers/globalHelpers";
import { AUTH_TOKEN } from "../../../constants/storageKeys";
import IntegrationResultModal from '../IntegrationResultModal';
import HtmlTooltip from '../HtmlTooltilp';
import { formatDateOnFront } from "../../../lib/helpers";
import { CheckCircle, Error, GppMaybe, OpenInNew } from "@mui/icons-material";
import appHelpers, { getAppInfo } from "../../../common/helpers/appHelpers";
import { clearErpIntegrationCustomer } from "../../../store/slices/erpIntegrationCustomerSlice";
import UpdateOrderErpParametersModal from "./UpdateOrderErpParametersModal";
import { postWebViewMessage } from "../../../common/helpers/messageHelper";
import { muiMenuStyles } from "../../../constants/muiMenuStyles";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import UpdateOrderErpCustomerModal from "./UpdateOrderErpCustomerModal";

const format = "DD MMMM dddd YYYY";


export default function IntegrationTable({
  formFilterRef,
  getHeadCells,
  tableSelectedRows,
  page,
  pageSize,
  setPage,
  setPageSize,
  requestParameters }) {
  const classes = muiMenuStyles();

  const { erpParameter } = useSelector((state) => state.erpParameters);
  const { firmInformations } = useRecoilValue(tenantState);

  const platform = appHelpers.getPlatform();
  const isWebPlatform = platform == "web";

  const isNetsis = firmInformations.erpType == "NETSIS";

  const [anchorEl, setAnchorEl] = React.useState(null);
  const isopenMenu = Boolean(anchorEl);

  const confirmModalRef = useRef();
  const reportTableRef = useRef();
  const resultModalRef = useRef();
  const customerModalRef = useRef();
  const updateOrderErpParameterModalRef = useRef();
  const updateCustomerErpSelectRef = useRef();

  const [dropdownMenuId, setDropdownMenuId] = useState("");
  const [dropdownAllValues, setDropdownAllValues] = useState("");

  const [operationsLoading, setOperationsLoadng] = useState(false);
  const [integrationResultModalVisible, setIntegrationResultModalVisible] = useState(false);
  const [integrationKeyMatch, setIntegrationKeyMatch] = useState("");


  const dispatch = useDispatch();
  const thunkdispatch = useDispatch();
  const {
    integrationList,
    totalCount,
    currentPage,
    isFetching,
    isError,
    isloadingIntegration,
    integrationKey,
    isSyncOrders,
    integrationResults
  } = useSelector((state) => state.Integration);
  const { selectedCustomer } = useSelector((state) => state.erpIntegrationCustomer);

  const [updatedOrderId, setUpdatedOrderId] = useState(0);
  const [selectedCustomerCode, setSelectedCustomerCode] = useState(0);

  const loading = useLoading(isFetching);
  useLayoutEffect(() => {
    dispatch(clearErpIntegrationCustomer());
    dispatch(changeIntegrationLoading(false));
  }, []);

  useEffect(() => {
    var message = "";
    if (selectedCustomer.code != null && selectedCustomer.code != undefined) {
      if (dropdownAllValues.customercode != null && selectedCustomer.code != undefined) {
        message = "Seçilen kaydın  '" + dropdownAllValues.customercode + "' Cari Hesap Kodu  '" + selectedCustomer.code + "' olarak  güncellenecektir?";
      } else {
        message = "Seçilen kaydın Cari Hesap Kodu " + selectedCustomer.code + " olarak  güncellenecektir?";
      }
      if (dropdownMenuId > 0) {
        confirmModalRef.current.showConfirm({
          title: "Uyarı!",
          contentText: message,
          confirmText: "Onayla",
          cancelText: "İptal",
          confirmCallBack: () => updateCustomerCodeAtOrder(selectedCustomer, dropdownMenuId)
        });
      }
    }
  }, [selectedCustomer]);

  useEffect(() => {
    controlIntegrationComplete();
  }, [integrationKeyMatch]);

  useEffect(() => {
    getHeadCells(headCells);
    // refreshUserTable(dispatch);
  }, []);

  const updateCustomerCodeAtOrder = async (selectedCus, id) => {
    setSelectedCustomerCode(selectedCus.code);
    var params = {
      customerCode: code,
      customerName: selectedCus.description,
      orderId: id
    }
    setUpdatedOrderId(id);
    const { isSuccess, data, errorMessage } = await commonNetwork.post("/integration/UpdateCustomerCodeAtOrder/", params);
    if (isSuccess) {
      const parameters = {
        timeStart: "",
        timeEnd: "",
        paymentProvider: "",
        isSync: false,
        customerCode: ""
      };
      dispatch(clearErpIntegrationCustomer())
      setTimeout(() => {
        dispatch(getIntegrationList({ parameters }));
      }, 550);
    }
  }
  const controlIntegrationComplete = () => {


    if (integrationKey == integrationKeyMatch && integrationKeyMatch.length > 0) { // aktarılan ödemeler tamamlandı, başarılı olayını kontrol et
      setIntegrationKeyMatch("");
      dispatch(changeIntegrationLoading(false));
      setIntegrationResultModalVisible(true);
      resultModalRef.current.showMessage(integrationResults);

      tableSelectedRows.current.clearSelected();
      submitFilterForm();
    }

  }

  const openCustomerForm = (orderid) => {

    var callbackParameters = {
      customerSelectFrom: customerSelectFrom.fromErpIntegration,
      orderid: orderid
    }
    var messageBody = { requestType: postMessageTypes.getCustomerInfo, requestBody: "", callbackParameters: JSON.stringify(callbackParameters) };
    postWebViewMessage(JSON.stringify(messageBody));
  }

  const updateErpParametersClick = () => {
    updateOrderErpParameterModalRef.current.openModal(dropdownAllValues);
  }

  const onUpdateOrderErpParameter = (fields) => {

    var parsedList = JSON.parse(JSON.stringify(integrationList));
    var index = parsedList.findIndex(w => w.orderid == fields.orderid);

    for (var key in fields) {
      if (fields.hasOwnProperty(key)) {
        parsedList[index][key] = fields[key];
      }
    }

    dispatch(updateIntegrationList(parsedList));
  }

  const onUpdateOrderErpCustomerParameter = (fields) => {

    var parsedList = JSON.parse(JSON.stringify(integrationList));
    var index = parsedList.findIndex(w => w.orderid == fields.orderid);

    for (var key in fields) {
      if (fields.hasOwnProperty(key)) {
        parsedList[index][key] = fields[key];
      }
    }

    dispatch(updateIntegrationList(parsedList));
  }

  const handleClickMenu = (event, orderid, row) => {
    setDropdownMenuId(orderid);
    setDropdownAllValues(row);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function getListItem(id) {
    var itemIndex = integrationList.findIndex(w => w.orderid == id);
    if (itemIndex != -1) {
      var item = integrationList[itemIndex];
      return item;
    } else {
      return null;
    }
  }

  const orderSyncStatusHandle = (isSyncOrders) => {
    setAnchorEl(null);
    var message = isSyncOrders ? "Aktarılmadı " : "Aktarıldı "
    confirmModalRef.current.showConfirm({
      title: "Uyarı!",
      contentText: "Fiş Durumu " + message + " olarak değiştirilecektir. Emin misiniz?",
      confirmText: "Onayla",
      cancelText: "İptal",
      confirmCallBack: () => changeOrderSyncStatus(isSyncOrders)
    });
  }
  const changeOrderSyncStatus = async (makeUnSync) => {
    setOperationsLoadng(true);
    const params = {
      makeUnSync: makeUnSync,
      orderId: dropdownMenuId
    }

    const { isSuccess, data, errorMessage } = await commonNetwork.post("/integration/setOrderSyncStatus", params);
    if (isSuccess) {
      toast.success("Aktarım durumu başarılı bir şekilde değiştirildi");
      submitFilterForm();
    } else {
      toast.error(errorMessage);
    }

    setOperationsLoadng(false);
  }

  const onPostClick = async () => {

    var list_for_integration = [];

    var selectedRows = tableSelectedRows.current.getSelectedRows();
    var isNullCustomerCode = true;
    if (selectedRows.length > 0) {
      dispatch(changeIntegrationLoading(true));

      var params = [];
      let webParams = [];
      for (let i = 0; i < selectedRows.length; i++) {
        const element = selectedRows[i];
        var item = getListItem(element);
        if (item != null) {
          if (item.customercode != null) {
            isNullCustomerCode = false;
          } else {
            if (isNullCustomerCode) {
              isNullCustomerCode = true;
            }
          }
          list_for_integration.push({
            ...item
          });
          var customeridd = 0;
          if (item.customerid) {
            customeridd = parseInt(item.customerid);
          }
          var synccustomeridd = -1;
          if (item.synccustomercode) {
            synccustomeridd = parseInt(item.synccustomercode);

          }

          params.push({
            OrderId: element,
            VpId: item.vpid,
            Synccustomercode: synccustomeridd,
            Customerid: customeridd
          });
          webParams.push(element);
        }
      } if (isNullCustomerCode && selectedRows.length >= 1) {
        toast.error("Cari Hesap Kodu boş olamaz");
        dispatch(changeIntegrationLoading(false));
      }
      else {

        if (isWebPlatform) {
          await runIntegrationOnWeb(webParams);
        } else {
          const { isSuccess, data, errorMessage } = await commonNetwork.post("/integration/getErpParameters", params);
          if (isSuccess) {

            for (let i = 0; i < data.length; i++) {
              const element = data[i];
              var index = list_for_integration.findIndex(w => w.orderid == element.orderId);

              for (const key in element) {
                list_for_integration[index][key] = element[key];
              }
            }

            onIntegrationPostConfirm(list_for_integration);

          } else {
            dispatch(changeIntegrationLoading(false));
            toast.error("Ödeme aktarılırken hata meydana geldi. Lütfen yetkili ile iletişime geçin.");
          }
        }
      }
    } else {
      toast.error("Lütfen ödeme seçiniz");
    }
  }

  const runIntegrationOnWeb = async (params) => {

    const { isSuccess, data } = await commonNetwork.post("/integration/submit-payments", params);

    dispatch(changeIntegrationLoading(false));
    if (isSuccess) {
      resultModalRef.current.showMessage(data);
      setIntegrationResultModalVisible(true);
      submitFilterForm();

    } else {
      toast.error("Ödeme aktarılırken hata meydana geldi. Lütfen yetkili ile iletişime geçin.");
    }
  }
  const onIntegrationPostConfirm = (list_for_integration) => {


    var body = JSON.stringify(list_for_integration);
    var token = localStorage.getItem(AUTH_TOKEN);
    var guid = generateUUID();
    setIntegrationKeyMatch(guid);
    var messageBody = {
      requestType: postMessageTypes.integration,
      requestBody: body,
      requestDetailType: integrationRequestTypes.creditCard,
      messageGuid: guid,
      accessToken: token,
      serviceUrl: process.env.REACT_APP_BASE_URL + "/api/v1"
    };
    postWebViewMessage(JSON.stringify(messageBody));

    submitFilterForm();
  }


  const submitFilterForm = (id) => {


    if (formFilterRef && formFilterRef.current) {
      formFilterRef.current.submitform();
    }
  }

  const openFastPaymentForm = () => {

    var serial = dropdownAllValues.erpdocumentid;
    var documentId = serial;
    var netsisvalues = [];

    netsisvalues.push(documentId);

    var params = {
      formId: "6",
      logicalRef: "15",
      modeType: openFormOperationType.view,
      values: JSON.stringify(netsisvalues)
    }
    var messageBody = {
      requestType: postMessageTypes.openFormByParameter,
      requestBody: JSON.stringify(params)
    };
    openFormByParameter(messageBody);
  }


  const openDocumentFromErp = () => {


    var platform = appHelpers.getPlatform();
    var params = {
      formId: "510",
      logicalRef: dropdownAllValues.erpdocumentid,
      modeType: openFormOperationType.view
    }
    if (platform == "NETSIS") {


      const isReceipt = dropdownAllValues.synctypeid == 2 ? true : false;

      if (dropdownAllValues.synctypeid == 4) {
        openFastPaymentForm();
      } else
        if (isReceipt) {
          var serial = dropdownAllValues.erpdocumentserialcode;
          var documentId = dropdownAllValues.erpdocumentid;
          var netsisvalues = [];
          netsisvalues.push(serial + "");
          netsisvalues.push(documentId + "");

          params = {
            formId: "11",
            logicalRef: "2",
            modeType: openFormOperationType.view,
            values: JSON.stringify(netsisvalues)
          }
        } else {
          var serial = dropdownAllValues.erpdocumentserialcode;
          var documentId = dropdownAllValues.erpdocumentid;
          var netsisvalues = [];

          netsisvalues.push(dropdownAllValues.orderdatestr);
          netsisvalues.push("G");
          netsisvalues.push(dropdownAllValues.erpbankcode);
          // netsisvalues.push("alici2");
          params = {
            formId: "6",
            logicalRef: "2",
            modeType: openFormOperationType.view,
            values: JSON.stringify(netsisvalues)
          }
        }

    }


    var messageBody = {
      requestType: postMessageTypes.openFormByParameter,
      requestBody: JSON.stringify(params)
    };
    openFormByParameter(messageBody);
  }

  const getErpDocumentCode = (row) => {

    if (isNetsis) {

      return row.erpdocumentserialcode + " - " + row.erpdocumentid;
    } else {
      return row.erpdocumentcode;
    }
  }

  const updateCustomerErpClick = () => {
    updateCustomerErpSelectRef.current.openModal(dropdownAllValues);
  }

  const DropdownMenu = (rows) => {


    return (
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={isopenMenu}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        classes={{
          paper: classes.paper,
        }}
      >
        <MenuItem onClick={() => {

          orderSyncStatusHandle(isSyncOrders)
        }}>
          {isSyncOrders ? (
            <ListItemIcon>
              <GppMaybe fontSize="small" />
            </ListItemIcon>
          ) : (
            <ListItemIcon>
              <CheckCircle fontSize="small" className="" />
            </ListItemIcon>
          )}

          {isSyncOrders ? "Aktarılmadı Yap" : "Aktarıldı Yap"}
        </MenuItem>

        {(dropdownAllValues.erpdocumentid > 0 && platform != "web") ? (
          <MenuItem onClick={() => {
            openDocumentFromErp()
          }}>
            <ListItemIcon>
              <OpenInNew fontSize="small" />
            </ListItemIcon>
            Fiş İncele
          </MenuItem>
        ) : null}
        {isWebPlatform ? null : (dropdownAllValues.customercode == null || dropdownAllValues.customercode == undefined) ? (
          <MenuItem onClick={() => {
            openCustomerForm(dropdownMenuId);
            setAnchorEl(null);
          }}>
            <ListItemIcon>
              <AddCircle fontSize="small" />
            </ListItemIcon>
            Cari Hesap Seç
          </MenuItem>
        ) : (
          <MenuItem onClick={() => {
            openCustomerForm(dropdownMenuId);
            setAnchorEl(null);
          }}>
            <ListItemIcon>
              <Sync fontSize="small" />
            </ListItemIcon>
            Cari Hesap Değiştir
          </MenuItem>
        )}

        {!isSyncOrders ? (
          <MenuItem onClick={() => {
            updateErpParametersClick(dropdownMenuId);
            setAnchorEl(null);
          }}>
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            Erp Parametrelerini Düzenle
          </MenuItem>
        ) : null}
        {!isSyncOrders && isWebPlatform ? (
          <MenuItem onClick={() => {
            updateCustomerErpClick(dropdownMenuId);
            setAnchorEl(null);
          }}>
            <ListItemIcon>
              <FormatListBulleted fontSize="small" />
            </ListItemIcon>
            Cari Hesap Değiştir
          </MenuItem>
        ) : null}
      </Menu>
    );
  }


  const getIntegrationStatus = (row) => {
    if (row.status == false) {

      if (row.syncerrordesc) {

        return (
          <HtmlTooltip
            title={
              <React.Fragment>
                <Typography color="inherit">ERP Aktarım Hata Detayı</Typography>
                <label className="font-bold">Hata Kodu: </label>  {row.syncerrorcode}
                <br />
                <label className="font-bold">Hata Mesajı: </label>  {row.syncerrordesc}

              </React.Fragment>
            }
          >
            <Error className='text-error-text' />
          </HtmlTooltip>
        );
      }

      else {
        if (row.customercode == null && !isSyncOrders) {
          return (
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit"> Uyarı</Typography>
                  <label className="font-bold">Uyarı Mesajı : </label>
                  Cari Kod boş olduğu için aktarım yapılamaz.
                  <br />
                </React.Fragment>
              }
            >
              <Error className='text-error-yellow' />
            </HtmlTooltip>
          );
        }
      }

    }
    else {
      if (row.customercode == null && !isSyncOrders) {
        return (
          <HtmlTooltip
            title={
              <React.Fragment>
                <Typography color="inherit"> Uyarı</Typography>
                <label className="font-bold">Uyarı Mesajı : </label>
                Cari Kod boş olduğu için aktarım yapılamaz.
                <br />
              </React.Fragment>
            }
          >
            <Error className='text-error-yellow' />
          </HtmlTooltip>
        );
      }
    }
  }

  const headCells = [
    {
      id: 'orderid',
      numeric: true,
      disablePadding: false,
      label: 'Id',
      className: "min-w-[70px]",
      colWidth: 40, // For excel
      isprimary: true,
      hide: true
    },
    {
      id: 'operations',
      numeric: false,
      label: 'İşlemler',
      exceptToExcel: true,
      disablePadding: true,
      isRender: true,
      disableSortIcon: true,
      renderRow: (row) => {
        return (
          <div className="flex flex-row justify-around items-center">

            <a id="basic-button"
              aria-controls={isopenMenu ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={isopenMenu ? 'true' : undefined}
              className="cursor-pointer"
              onClick={(event) => handleClickMenu(event, row.orderid, row)}>
              <FaEllipsisV
                className="block sm:block ml-3 h-3 w-3 font-light"

              />
            </a>

            <DropdownMenu rows={row}>

            </DropdownMenu>
            <div style={{
              width: 24
            }}>
              {getIntegrationStatus(row)}
            </div>
          </div>
        );

      }
    },
    {
      id: 'customercode',
      numeric: true,
      disablePadding: false,
      label: 'Cari Hesap Kodu',
      colWidth: 40, // For excel
      className: "min-w-[155px]",
      maxLength: 20,
      isRender: true,
      renderRow: (row) => {

        return (
          row.orderid == updatedOrderId ? (
            <div className="">
              {selectedCustomerCode}
            </div>
          ) : (
            <div className="">
              {row.customercode}
            </div>
          )

        );
      }
    },
    {
      id: 'customername',
      numeric: true,
      disablePadding: false,
      label: 'Cari Hesap Ünvan',
      className: "min-w-[360px]",
      colWidth: 40, // For excel
      maxLength: 50
    },
    {
      id: 'orderdate',
      numeric: true,
      disablePadding: false,
      label: 'Tarih',
      className: "min-w-[130px]",
      isRender: true,
      colWidth: 25, // For excel
      renderRow: (row) => {

        return (
          <div className="">
            {formatDateOnFront(row.orderdate)}
          </div>
        );
      }
    },
    {
      id: 'lastamount',
      numeric: true,
      disablePadding: false,
      label: 'Tutar ',
      className: "min-w-[140px]",
      isMoney: true,
      maxLength: 15
    },
    {
      id: 'vpDisplayName',
      disablePadding: false,
      label: 'Ödeme Altyapısı',
      className: "min-w-[180px]",
      colWidth: 40, // For excel
      maxLength: 30
    },
    {
      id: "erpbankcode",
      disablePadding: false,
      label: 'ERP Banka Kodu',
      className: "min-w-[180px]",
      colWidth: 40, // For excel
      maxLength: 30
    },
    {
      id: "erpprojectcode",
      disablePadding: false,
      label: 'ERP Proje Kodu',
      className: "min-w-[180px]",
      colWidth: 40, // For excel
      maxLength: 30
    },
    {
      id: "erpsalesmancode",
      disablePadding: false,
      label: 'ERP Plasiyer Kodu',
      className: "min-w-[180px]",
      colWidth: 40, // For excel
      maxLength: 30
    }
  ];
  var erpDocNumberColumn = {}
  if (isSyncOrders) {
    erpDocNumberColumn = {
      id: "erpdocumentcode",
      disablePadding: false,
      label: 'ERP Fiş No',
      className: "min-w-[180px]",
      colWidth: 40, // For excel
      maxLength: 30,
      isRender: true,
      renderRow: (row) => {

        return (
          <div className="">
            {getErpDocumentCode(row)}
          </div>
        );
      }
    }
    headCells.push(erpDocNumberColumn);
  }

  if (isNetsis) {
    var extraItems = [
      {
        id: "erpbranchcode",
        disablePadding: false,
        label: 'ERP Şube Kodu',
        className: "min-w-[180px]",
        colWidth: 40, // For excel
        maxLength: 30
      },
      {
        id: "erpreferencecode",
        disablePadding: false,
        label: 'ERP Referans Kodu',
        className: "min-w-[180px]",
        colWidth: 40, // For excel
        maxLength: 30
      },
      {
        id: "erpcontractcode",
        disablePadding: false,
        label: 'ERP Sözleşme Kodu',
        className: "min-w-[180px]",
        colWidth: 40, // For excel
        maxLength: 30
      }
    ];
    headCells.push.apply(headCells, extraItems);
  }

  function LinearColor() {
    if (operationsLoading) {
      return (
        <ProgressLoader />
      );
    }
  }

  const bottomElement = isSyncOrders ? null :
    <div className="pb-12 mt-5 mt-4 flex justify-end space-x-2">
      <Button
        color="primary"
        hover="primary"
        size="xs"
        callback={() => onPostClick()}
        disabled={isloadingIntegration}
        loading={isloadingIntegration}
      >
        Fiş Oluştur
      </Button>
    </div>

  return (

    <>

      {LinearColor()}


      <ConfirmationModal ref={confirmModalRef}></ConfirmationModal>
      <MaterailTable
        ref={tableSelectedRows}
        headerCells={headCells}
        tableData={integrationList}
        isRowSelect
        bottomElement={bottomElement}
        isLoading={loading}
        emptyMessage={"Verilen kritere uygun kayıt bulunamamıştır."} isError={isError}
        onPageChange={(newPage) => {
          setPage(newPage);
          thunkdispatch(getIntegrationList({
            ...requestParameters,
            pageNumber: newPage,
            pageSize: pageSize
          }));
        }}
        onRowsPerPageChange={(newRows) => {
          setPageSize(newRows);
          setPage(1);
          thunkdispatch(getIntegrationList({
            ...requestParameters,
            pageNumber: 1,
            pageSize: newRows
          }));
        }}
        totalDataCount={totalCount}
        currentPage={currentPage}
      ></MaterailTable>

      <UpdateOrderErpParametersModal ref={updateOrderErpParameterModalRef}
        onUpdateOrderErpParameter={onUpdateOrderErpParameter}
      ></UpdateOrderErpParametersModal>
      <UpdateOrderErpCustomerModal ref={updateCustomerErpSelectRef}
        onUpdateOrderErpCustomerParameter={onUpdateOrderErpCustomerParameter}
      ></UpdateOrderErpCustomerModal>
      <IntegrationResultModal ref={resultModalRef} statusModalVisible={integrationResultModalVisible} setStatusModalVisible={setIntegrationResultModalVisible}></IntegrationResultModal>
    </>

  );
}
